import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RondeivuHttpClient } from 'src/app/handlers';
import { environment } from 'src/environments/environment';
import { IDealCard } from '../../shared/models';
import { IDocument } from '../models';

@Injectable({
  providedIn: 'root'
})
export class DealPreviewService {

  private readonly BASE_URL = environment.rondeivu_api;
  private readonly FRAGMENT = '/dealpreview';
  
  constructor(private http: RondeivuHttpClient) { }


  getLiveDealsPreview() : Observable<IDealCard[]> {
    return this.http.get<IDealCard[]>(this.BASE_URL + this.FRAGMENT);
  }

  getDealPreviewById(dealId: string): Observable<IDealCard> {
    return this.http.get<IDealCard>(this.BASE_URL + this.FRAGMENT + "/" + dealId);
  } 

  getDealPreNdaDataroom(dealId: string): Observable<IDocument[]> {
    return this.http.get<IDocument[]>(this.BASE_URL + this.FRAGMENT + "/dataroom/" + dealId);
  }

  getDealPreviewDataroomById(dealId: string): Observable<IDealCard> {
    return this.http.get<IDealCard>(this.BASE_URL + this.FRAGMENT + "/download/" + dealId);
  }

  getDealPreNdaDataroomDocumentById(docId: string): Observable<any> {
    return this.http.get(this.BASE_URL + this.FRAGMENT + `/dataroom/document/${docId}`, { responseType: 'blob' });
  }

  sendDealInterestAsGuest(data: GuestUserDealInterest) : Observable<any> {
    return this.http.post(this.BASE_URL + this.FRAGMENT + `/deal-interest-as-guest/${data.dealId}`, data);
  }

  sendDealInterestAsUser(data: LoggedInUserDealInterest) : Observable<any> {
    return this.http.post(this.BASE_URL + this.FRAGMENT + `/deal-interest-as-user/${data.dealId}`, data);
  }
}

export interface GuestUserDealInterest {
  name: string;
  email: string;
  phone?: string;
  company: string;
  title: string;
  notes?: string;
  dealId: string;
  timezone?: string;
}

export interface LoggedInUserDealInterest {
  notes?: string;
  dealId: string;
}


